import styled from "@emotion/styled";

export const SidebarActions = styled.div`
  display: flex;
  align-items: center;
`;
